import { IPlatformReminder } from '@torim-app/types';
import { platformUrlBuilder, platformFetch } from './utils';

export interface IRemindersListQuery {
  completed?: boolean;
  bid?: string;
  leadId?: string;
  assignedTo?: string;
  from?: string;
  to?: string;
}

export class RemindersApi {
  static async list(query: IRemindersListQuery = {}): Promise<IPlatformReminder[]> {
    const params: Record<string, string | number> = {};
    if (query.completed !== undefined) params.completed = String(query.completed);
    if (query.bid) params.bid = query.bid;
    if (query.leadId) params.leadId = query.leadId;
    if (query.assignedTo) params.assignedTo = query.assignedTo;
    if (query.from) params.from = query.from;
    if (query.to) params.to = query.to;

    const url = platformUrlBuilder(params, 'reminders');
    const response = await platformFetch(url);
    if (!response.ok) throw 'Failed to fetch reminders';
    return response.json();
  }

  static async create(data: Partial<IPlatformReminder>): Promise<IPlatformReminder> {
    const url = platformUrlBuilder({}, 'reminders');
    const response = await platformFetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    if (!response.ok) throw 'Failed to create reminder';
    return response.json();
  }

  static async update(id: string, data: Partial<IPlatformReminder>): Promise<IPlatformReminder> {
    const url = platformUrlBuilder({}, `reminders/${id}`);
    const response = await platformFetch(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    if (!response.ok) throw 'Failed to update reminder';
    return response.json();
  }

  static async delete(id: string): Promise<{ success: true }> {
    const url = platformUrlBuilder({}, `reminders/${id}`);
    const response = await platformFetch(url, { method: 'DELETE' });
    if (!response.ok) throw 'Failed to delete reminder';
    return response.json();
  }

  static async runAutomations(): Promise<{ trialReminders: number }> {
    const url = platformUrlBuilder({}, 'reminders/run-automations');
    const response = await platformFetch(url, { method: 'POST' });
    if (!response.ok) throw 'Failed to run automations';
    return response.json();
  }
}
